import { render, staticRenderFns } from "./VehiclesStockSoldLong.vue?vue&type=template&id=29fb2e11&"
import script from "./VehiclesStockSoldLong.vue?vue&type=script&lang=js&"
export * from "./VehiclesStockSoldLong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports